import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  props: {
    locked: { type: Boolean }
  },
  emits: ['toggle-lock'],
  setup(__props: any, { emit }) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["p-1 px-3 transition-colors bg-green-300 rounded-lg text-lg", { 'bg-pink-400': __props.locked }]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('toggle-lock')))
  }, [
    _createElementVNode("i", {
      class: _normalizeClass(["fas", __props.locked ? 'fa-lock' : 'fa-unlock'])
    }, null, 2)
  ], 2))
}
}

})